<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <!-- Select creditors -->
      <v-flex xs12 md4>
        <SelectCreditors
          :multiple="false"
          :clearable="false"
          :negotiation="true"
          :selected="selectedCreditor"
          :disabled="loading"
          @selectedCreditors="changeSelectCreditors($event)"
        ></SelectCreditors>
      </v-flex>

      <!-- Select estruturas de árvore -->
      <v-flex xs12 md4 d-flex flex-row align-start>
        <v-select
          box
          flat
          success
          clearable
          item-value="id"
          item-text="name"
          no-data-text="Sem dados"
          label="Estruturas de árvore"
          hide-details
          :items="orderDebtBases"
          :disabled="!selectedCreditor || loading"
          v-model="selectedBaseId"
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-tile-content v-on="on" v-bind="attrs">
              <div style="display: flex; width: 100%">
                <span
                  class="ma-auto"
                  :class="
                    item.id == selectedBaseId
                      ? 'primary--text'
                      : item.status == 'ARCHIVED'
                      ? 'grey--text'
                      : ''
                  "
                >
                  {{ item.name }}
                </span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: toolOn, attrs: toolAttrs }">
                    <div
                      v-on="toolOn"
                      v-bind="toolAttrs"
                      :class="
                        item.id == selectedBaseId
                          ? 'deep-purple lighten-5'
                          : setSelectTree(item.status, 'background')
                      "
                      style="border-radius: 50%; padding: 3px; height: 30px"
                    >
                      <v-icon
                        :color="
                          item.id == selectedBaseId
                            ? 'primary'
                            : setSelectTree(item.status, 'color')
                        "
                      >
                        {{ setSelectTree(item.status, "icon") }}
                      </v-icon>
                    </div>
                  </template>
                  <span>{{ setSelectTree(item.status, "tooltip") }}</span>
                </v-tooltip>
              </div>
            </v-list-tile-content>
          </template>
          <template v-slot:append-item>
            <v-divider class="mb-2"></v-divider>
            <v-list-tile>
              <v-btn block flat color="primary" @click.stop="newDebtBase"
                >criar árvore</v-btn
              >
            </v-list-tile>
          </template>
        </v-select>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="selectedBaseId"
              icon
              small
              style="max-width: min-content"
              v-on="on"
              v-bind="attrs"
              class="mt-3"
              :disabled="loading"
              @click="openEditDebtBase"
            >
              <v-icon color="primary" size="23">mdi-pencil</v-icon>
            </v-btn>
          </template>
          Editar arvore
        </v-tooltip>
      </v-flex>

      <!-- Tags dias da semana -->
      <v-flex xs12 md4 d-flex flex-row align-center>
        <div class="tagsWeekDay">
          <v-chip v-for="(weekDay, index) in weekDayName" class="green lighten-4 green--text text--darken-2 " :key="index">
          {{ weekDay }}
        </v-chip>
        </div>
      </v-flex>
      <!-- Loading -->
      <v-flex xs12 class="text-xs-center mt-5" v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
        ></v-progress-circular>
      </v-flex>
      <!-- Tree -->
      <v-flex xs12 v-else-if="treeData">
        <TreeMain
          :data="[...treeData]"
          :options="treeOptions"
          :treeStatus="getTreeSelected.status"
          @add="addNode"
          @info="infoNode"
          @edit="editNode"
          @exclude="excludeNode"
          @newStimulus="newStimulus"
          @updateTree="openDialogConfirm($event.status, $event.unarchive, $event.activeAt)"
        />
      </v-flex>
      <!-- Sem dados -->
      <v-flex xs12 class="text-xs-center mt-5" v-else>
        <p class="title mb-0">Não há dados para carregar na árvore.</p>
      </v-flex>
    </v-layout>
    <!-- Dialog novo/editar nó -->
    <DialogNode
      :node="node"
      :isEdit="isEditingNode"
      :dialog.sync="dialogNode"
      :debtBaseId="selectedBaseId"
      :selectedWeekDays="weekDayName"
      @renderTree="renderTree"
      @updateTree="updateTree"
      @updatedDebtBase="updatedDebtBase"
    />
    <!-- Dialog análise do nó -->
    <DialogNodeAnalysis
      :data="nodeData"
      :creditor="getCreditor"
      :dialog.sync="dialogNodeAnalysis"
    />
    <!-- Dialog confirmação -->
    <DialogConfirmArchiving
      :dialog.sync="dialogConfirmArchiving"
      :deleteStructure="deleteStructure"
      :name="node ? node.name : '-'"
      :deleteSons="node._childrenLen ? true : false"
      @archiveNode="archiveNode()"
    />
    <!--  -->
    <DialogNewDebtBase
      :defaultName="newDebtBaseName"
      :creditorId="selectedCreditor"
      :debtBase="editingDebtBase"
      :dialog.sync="dialogNewDebtBase"
      @renderTree="renderTree"
      @updateDebtBase="updateDebtBase"
      @debtBaseEdited="onDebtBaseEdited"
    />
    <!--  -->
    <DialogConfirm
      :status="statusTree"
      :isUnarchive="unarchive"
      :dialog.sync="dialogConfirm"
      @confirmed="updateStatusTree"
    />
  </v-container>
</template>

<script>
import store from "@/store";
import creditorService from "@/services/creditor";
import TreeMain from "./components/trees/treeMain";
import DialogNode from "./components/dialogs/dialogNode";
import DialogConfirm from "./components/dialogs/dialogConfirm";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import DialogNewDebtBase from "./components/dialogs/dialogNewDebtBase";
import DialogNodeAnalysis from "./components/dialogs/dialogNodeAnalysis";
import treeService from "@/services/consolidation-tree/consolidation-tree";
import DialogConfirmArchiving from "./components/dialogs/dialogConfirmArchiving";

export default {
  name: "consolidation-tree",
  components: {
    TreeMain,
    DialogNode,
    DialogConfirm,
    SelectCreditors,
    DialogNewDebtBase,
    DialogNodeAnalysis,
    DialogConfirmArchiving,
  },
  data: function () {
    return {
      loading: false,
      unarchive: false,
      dialogNode: false,
      isEditingNode: false,
      dialogConfirm: false,
      deleteStructure: false,
      dialogNewDebtBase: false,
      dialogNodeAnalysis: false,
      editingDebtBase: null,
      dialogConfirmArchiving: false,
      selectedBaseId: 0,
      selectedCreditor: 0,
      statusTree: "",
      newDebtBaseName: "",
      debtBases: [],
      weekDayName: [],
      dictWeekDay: [
      {name: 'Segunda', value: 0},
      {name: 'Terça', value: 1},
      {name: 'Quarta', value: 2},
      {name: 'Quinta', value: 3},
      {name: 'Sexta', value: 4},
      {name: 'Sábado', value: 5},
      {name: 'Domingo', value: 6},
      ],

      creditors: [],
      dataForm: null,
      treeData: null,
      selectedNodeId: null,
      node: {},
      nodeData: { value: {}, last_resolution: {} },
      treeOptions: {
        parentSelect: true,
        propertyNames: {
          text: "name",
          data: "last_resolution",
          children: "children",
        },
      },
    };
  },
  async created() {
    try {
      this.loading = true;
      await this.getCreditors();
      let query = this.getQuery();
      if (Object.keys(query).length) {
        if (query.creditor) {
          await this.changeSelectCreditors(parseInt(query.creditor), true);
          if (query.baseId) {
            this.selectedBaseId = parseInt(query.baseId);
            await this.renderTree();
            if (query.nodeId) {
              this.infoNode(parseInt(query.nodeId));
            }
          }
        }
      }
    } catch (e) {
      this.$store.commit("showSnackbar", {
        message: "Houve um erro ao carregar os dados",
        color: "error"
      });
    } finally {
      this.loading = false;
    }
  },
  computed: {
    getCreditor() {
      if (!this.creditors.length) return {};
      let creditor = this.creditors.find((c) => c.creditor_id == this.selectedCreditor);
      return creditor ? creditor : {};
    },
    getTreeSelected() {
      if (!this.selectedBaseId) return {};
      let debtBases = this.debtBases.find((db) => db.id == this.selectedBaseId) || {};
      this.translateWeekDay(debtBases);
      return debtBases
    },
    orderDebtBases() {
      if (!this.debtBases.length) return [];
      let stimulate = this.debtBases.filter((db) => db.status == "STIMULATE");
      let analyzable = this.debtBases.filter((db) => db.status == "ANALYZABLE");
      let archived = this.debtBases.filter((db) => db.status == "ARCHIVED");
      return stimulate.concat(analyzable, archived);
    },
    getIdNodeRoot() {
      if (!this.debtBases.length || !this.selectedBaseId) return null;
      if (!this.getTreeSelected.nodes) return null;
      if (!this.getTreeSelected.nodes.length) return null;
      return this.getTreeSelected.nodes[0].id || null;
    },
  },
  watch: {
    selectedBaseId: {
      async handler() {
        if (this.loading) return;
        this.addfilters();
        this.loading = true;
        try {
          await this.renderTree();
        } finally {
          this.loading = false;
        }
      },
      deep: true,
    },
    dialogNodeAnalysis() {
      if (!this.dialogNodeAnalysis) {
        this.selectedNodeId = null;
        this.addfilters();
      }
    },
    dialogNode() {
      if (!this.dialogNode) {
        this.isEditingNode = false;
        this.addfilters();
      }
    },
    dialogNewDebtBase(val) {
      if (!val) this.editingDebtBase = null;
    },
  },
  methods: {
    /**
     * Carrega todos os credores.
     */
    async getCreditors() {
      await creditorService
        .list()
        .then((res) => (this.creditors = res.objects))
        .catch((err) => console.error(err));
    },
    getNode(id) {
      const searchNode = (no) => {
        for (let i = 0; i < no.length; i++) {
          if (no[i].id == id) return no;
          if (no[i].children && no[i].children.length) {
            return searchNode(no[i].children);
          }
        }
        return {};
      };
      return { ...searchNode(this.treeData)[0] };
    },
    /**
     * Carrega a query.
     *
     * @returns Retorna um objeto com os filtros da url.
     */
    getQuery() {
      let query = this.$route.query;
      if (query && !Object.keys(query).length) {
        query = store.getters.getDebtTreeFilters;
        this.setQuery(query);
      }
      this.setQuery(query);
      return query;
    },
    /**
     * Adiciona os filtros na url.
     *
     * @param {Object} query filtros
     */
    setQuery(query) {
      this.$store.commit("setDebtTreeFilters", query);
      if (this.$route.path == "/debt-tree/view") {
        this.$router.replace({
          name: "Árvore view",
          query: query,
        });
      }
    },
    /**
     * Ação ao selecionar um credor.
     *
     * @param {Number} event id do credor
     */
    async changeSelectCreditors(event, permission = false) {
      if (this.loading && !permission) return;
      this.selectedCreditor = event;
      await this.fetchBebtBases();
      if (!this.loading) {
        this.selectedBaseId = null;
        this.treeData = null;
      }
      this.addfilters();
    },
    /**
     * Carrega as estruturas de árvore.
     */
    async fetchBebtBases() {
      let bases = await treeService.listDebtBases(this.selectedCreditor);
      this.debtBases = bases.objects;
      if (this.debtBases.length == 1) {
        setTimeout(() => {
          this.selectedBaseId = this.debtBases[0].id;
        });
      } else {
        var debtBase = this.debtBases.find((d) => d.status == "STIMULATE");
        if (debtBase && debtBase.id) {
          setTimeout(() => {
            this.selectedBaseId = debtBase.id;
          });
        }
      }
    },

    /**
     * Carrega e renderiza os dados na árvore.
     */
    async renderTree() {
      if (this.selectedBaseId) {
        this.treeData = null;
        if (!this.getIdNodeRoot) return;
        try {
          await treeService
            .getNode(this.getIdNodeRoot, ["stimulus", "children"])
            .then((resp) => {
              const inclueStimulus = (node) => {
                node.last_resolution.stimulus = node.stimulus.filter(
                  (s) => s.active,
                );
                if (node.children.length) {
                  for (let i = 0; i < node.children.length; i++) {
                    inclueStimulus(node.children[i]);
                  }
                }
                return;
              };
              inclueStimulus(resp);

              if (resp) this.treeData = resp;
              else this.treeData = null;
            });
        } catch (e) {
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao carregar os nós",
            color: "error",
          });
        }
      } else {
        this.treeData = null;
      }
    },

    /**
     * Carrega e abre a dialog análise do nó.
     *
     * @param {Number} nodeId id do nó
     */
    async infoNode(node) {
      let nodeData = null;

      if (typeof node !== 'object') {
        try {
          nodeData = await treeService.getNode(node, ["last_resolution", "parent"]);
        } catch (error) {
          this.$store.commit("showSnackbar", {
            message: "Erro ao carregar informações do nó",
            color: "error",
          });
          return;
        }
      } else {
        nodeData = node;
      }

      if (!nodeData || !nodeData.id) {
        this.$store.commit("showSnackbar", {
          message: "Dados do nó inválidos",
          color: "error",
        });
        return;
      }

      this.selectedNodeId = nodeData.id;

      try {
        const resp = await treeService.getNodeHistory(nodeData.id);

        nodeData.history = resp.objects;
        nodeData.last_resolution = resp.objects[0];

        this.nodeData = nodeData;

        if (this.nodeData.created_at) {
          this.nodeData.created_at = new Date(this.nodeData.created_at).toISOString();
        }

        this.addfilters();
        this.dialogNodeAnalysis = true;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: "Erro ao carregar histórico do nó",
          color: "error",
        });
      }
    },

    /**
     * Carrega dos dados para seter a query.
     */
    addfilters() {
      if (this.loading) return;
      let query = {};
      if (this.selectedCreditor) {
        query.creditor = this.selectedCreditor;
        if (this.selectedBaseId) {
          query.baseId = this.selectedBaseId;
          if (this.selectedNodeId) query.nodeId = this.selectedNodeId;
          if (this.isEditingNode) query.editNodeId = this.node.id;
        }
      }
      this.setQuery(query);
    },
    /**
     * Abre a modal para criar um novo nó.
     *
     * @param {Object} node dados do nó
     */
    addNode(node) {
      this.node = node;
      this.isEditingNode = false;
      this.dialogNode = true;
    },
    translateWeekDay(selectedTree){
      // console.log(selectedTree);
      let prepareWeekDayArray = [];
      let prepareWeekDayName = [];
      if(selectedTree.prepare_week_day){
        prepareWeekDayArray = JSON.parse(selectedTree.prepare_week_day);
      }
      prepareWeekDayArray.sort((a,b) => a - b);
      prepareWeekDayArray.forEach(item => {
      let dayName = this.dictWeekDay.find((obj) => {
        return obj.value == item
      });
      if (!prepareWeekDayName.includes(dayName.name)) {
        // Adicionar o valor ao array usando push
        prepareWeekDayName.push(dayName.name);
      }
      })
      this.weekDayName = prepareWeekDayName;
      // console.log(this.weekDayName);
      // return this.weekDayName;
    },
    /**
     * Abre a modal para editar um nó.
     *
     * @param {Object} node dados do nó
     */
    editNode(node) {
      this.node = node;
      this.isEditingNode = true;
      this.addfilters();
      this.dialogNode = true;
    },
    /**
     * Abre a modal para excluir um nó.
     *
     * @param {Object} node dados do nó
     */
    excludeNode(node) {
      this.deleteStructure = false;
      if (node.id == this.treeData.id && node.name == this.treeData.name) {
        this.deleteStructure = true;
      }
      this.node = node;
      this.dialogConfirmArchiving = true;
    },
    /**
     * FIXME criar outro método para desativar o debt base_id quando o nó for o raiz
     * (botao de remove foi removido por enquanto)
     */
    async archiveNode() {
      await treeService
        .patchNode(this.node.id, { active: false })
        .then(() => {
          const deleteNode = (node, oldNode) => {
            var index = node.children.map((c) => c.id).indexOf(oldNode.id);
            if (index !== -1) {
              node.children.splice(index, 1);
              return;
            } else {
              for (let i = 0; i < node.children.length; i++) {
                deleteNode(node.children[i], oldNode);
              }
            }
          };
          deleteNode(this.treeData, this.node);
          this.$store.commit(
            "showSnackbar",
            `${this.node.name} foi removido com sucesso!`
          );
        })
        .catch((e) => {
          console.error("Erro ao desativar nó", e);
        });

      if (this.deleteStructure) {
        await treeService
          .patchDebtBase(this.selectedBaseId, { active: false })
          .then(() => {
            let index = this.debtBases.map(({ id }) => id).indexOf(this.selectedBaseId);
            this.debtBases.splice(index, 1);

            this.treeData = null;
            this.selectedBaseId = null;

            this.$store.commit("showSnackbar", `Estrutura removido com sucesso!`);
          })
          .catch((e) => {
            console.error("Erro ao desativar a estrutura da árvore!", e);
          });
      }

      this.dialogConfirmArchiving = false;
    },
    /**
     * Atualiza a árvore
     *
     * @param {Object} node dados do nó
     */
    updatedDebtBase(data){
      // console.log(data);
      this.getTreeSelected.prepare_week_day = data;
      this.translateWeekDay(this.getTreeSelected);
      this.weekDayName.sort((a,b) => a - b);
    },
    updateTree(data) {
      if (data.new) {
        const addNode = (node, newNode) => {
          if (node.id == newNode.parent_id) {
            node.children.push(newNode);
            return;
          } else {
            for (let i = 0; i < node.children.length; i++) {
              addNode(node.children[i], newNode);
            }
          }
        };
        addNode(this.treeData, data.node);
      } else {
        const updateNode = (node, newNode) => {
          if (node.id == newNode.id) {
            node.name = newNode.name;
            return;
          } else {
            for (let i = 0; i < node.children.length; i++) {
              updateNode(node.children[i], newNode);
            }
          }
        };
        updateNode(this.treeData, data.node);
      }
    },
    newDebtBase() {
      let currentCreditor = this.creditors.find(
        (el) => el.creditor_id == this.selectedCreditor
      );
      this.newDebtBaseName = `${currentCreditor.name} v${this.debtBases.length + 1}`;
      this.dialogNewDebtBase = true;
    },
    /**
     *
     */
    updateDebtBase(debtBase) {
      this.debtBases.push(debtBase);
      this.selectedBaseId = debtBase.id;
    },
    openEditDebtBase() {
      this.editingDebtBase = this.debtBases.find((db) => db.id === this.selectedBaseId);
      this.dialogNewDebtBase = true;
    },
    onDebtBaseEdited(updated) {
      const index = this.debtBases.findIndex((db) => db.id === updated.id);
      if (index !== -1) this.$set(this.debtBases, index, updated);
    },
    setSelectTree(type, prop) {
      switch (type) {
        case "ANALYZABLE":
          switch (prop) {
            case "icon":
              return "mdi-pause-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
            case "tooltip":
              return "Pausada";
          }
          break;
        case "STIMULATE":
          switch (prop) {
            case "icon":
              return "mdi-play-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
            case "tooltip":
              return "Iniciada";
          }
          break;
        case "ARCHIVED":
          switch (prop) {
            case "icon":
              return "mdi-archive-outline";
            case "color":
              return "grey";
            case "background":
              return "grey lighten-3";
            case "tooltip":
              return "Arquivada";
          }
          break;
      }
    },
    updateStatusTree(activeAt) {
      treeService
        .patchDebtBase(this.getTreeSelected.id, { status: this.statusTree, active_at: activeAt })
        .then((resp) => {
          let index = this.debtBases.findIndex((db) => db.id == this.selectedBaseId);
          this.debtBases[index].status = resp.status;
          let textStatus =
            this.statusTree == "ANALYZABLE"
              ? "pausada"
              : this.statusTree == "STIMULATE"
              ? "iniciada"
              : "arquivada";
          if (this.unarchive) {
            this.$store.commit("showSnackbar", "Há árvore foi desarquivada com sucesso!");
          } else {
            this.$store.commit(
              "showSnackbar",
              `Há árvore foi ${textStatus} com sucesso!`
            );
          }
        })
        .catch((error) => {
          console.error(error);
          let textStatus =
            this.statusTree == "ANALYZABLE"
              ? "pausar"
              : this.statusTree == "STIMULATE"
              ? "iniciar"
              : "arquivar";
          this.$store.commit("showSnackbar", `Houve um erro ao ${textStatus} a árvore!`);
        });
    },
    openDialogConfirm(status, unarchive, activeAt) {
      this.statusTree = status;
      this.unarchive = unarchive;
      this.activeAt = activeAt;
      this.dialogConfirm = true;
    },
    newStimulus(data) {
      this.$router.push({
        name: "Estímulos",
        query: {
          baseId: this.selectedBaseId,
          creditor: this.selectedCreditor,
        },
        params: {
          node: data.id,
          located: data.located,
        },
      });
    },
  },
};
</script>

<style lang="css">
.tagsWeekDay {
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: wrap;
}
</style>
